export const DROPDOWNS = {
  HELP: "HELP",
  NOTIFICATION: "NOTIFICATION",
  PROFILE: "PROFILE NEW",
};

export const MOE_HEADER = "AEH_AUTH_HEADER";

export const NOTIFICATION_TOAST_HEIGHT = 560;

export const SECONDS_IN_A_DAY = 86400;